module.exports = __webpack_public_path__ + "media/przekroczony_budzet.2e804760.mp3";